export default __webpack_public_path__ + "static/media/dom.4fcdbebb.png";